import moment from 'moment/moment';

export const formatDateTime = (
  dateTime: string,
  dateTimePattern: string
): string => {
  return moment.parseZone(dateTime).format(dateTimePattern);
};
